import get from './get';
import updateOrCreate from './update-or-create';

export default {
  get,
  create: updateOrCreate,
  update: updateOrCreate,
};
